import React, { useEffect, useState } from 'react';
import DiasGratis from "../../../images/20DiasGratis.svg";
import rellenaTusDatos from "../../../images/rellenaTusDatos.svg";
import successF20 from "../../../images/successF20.svg";
import './F20Landing.scss';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as schemas from '../../../assets/schemas/schemas';
import { idCodes, vehiclesEnum } from '../../../assets/helpers/options';
import { vehicleService } from '../../../services/vehicleService';
import { customerService } from '../../../services/customerService';
import { membershipService } from '../../../services/membershipService';
import { parsePhoneNumberWithError } from 'libphonenumber-js';
import PhoneInput from 'react-phone-number-input';
import { capitalize, filterParams } from '../../../assets/helpers/funciones';
import { notify } from '../../../assets/helpers/toast';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner';

// yup used within schemas; no local import needed here

// Local additions only for this view (vehicle mini fields)

export const F20Landing = (props) => {
    const { membership } = props
    const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
    const [isLoading, setIsloading] = useState(false);
    const [success, setSuccess] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        reset,
        control
    } = useForm({
        resolver: yupResolver(schemas?.F20Schema()),
        defaultValues: {
            // firstName: 'Prueba',
            // lastName: 'Prueba',
            // identificationType: 'V',
            // identification: '2341232',
            // // phone: '1231231231',
            // email: 'tes22t@asdas.com',
            // classType: '64691e105254c7956edd4db4',
            // year: '2001',
            // plate: 'asdsd',
        },
    });

    const appendFile = (data) => {
        const formData = new FormData();
        for (const key in data) {
            formData.append(key, data[key]);
        }

        formData.append('membership', membership?._id);
        return formData;
    };


    const updateMembershipStatus = (membershipId) => {
        setIsloading(true);
        membershipService
            .updateMembershipStatus(membershipId)
            .then((response) => {
                if ([200, 201].includes(response.status)) {
                    setIsloading(false);
                    setSuccess(true);
                    reset();
                } else {
                    setIsloading(false);
                    notify(`${response.message}`, 'error');
                }
            })
            .catch((error) => {
                setIsloading(false);
            });
    };


    const onSubmit = handleSubmit(async (data) => {
        data.firstName = capitalize(data?.firstName);
        data.lastName = capitalize(data?.lastName);
        data.email = data?.email?.toLowerCase();

        if (data.phone) {
            try {
                const parsedPhone = parsePhoneNumberWithError(data.phone, 'VE');
                data.phoneNumber = parsedPhone.nationalNumber;
                data.phonePrefix = '+' + parsedPhone.countryCallingCode;
            } catch (err) {
                console.warn('Invalid phone number, skipping parse:', err);
            }
        }

        delete data?.countryCode;
        delete data?.phone;

        const { plate, year, classType, ...dataClient } = data;

        let fileTopost = appendFile(filterParams(dataClient));
        if (!isLoading) {
            setIsloading(true);
            customerService
                .createCustomer(fileTopost)
                .then((response) => {
                    if ([200, 201].includes(response.status)) {
                        const vehicleData = {
                            plate: data?.plate,
                            year: data?.year,
                            customer: response?.data?._id,
                            customerIsOwner: "true",
                            armored: false,
                            class: data?.classType,
                            membership: membership?._id
                        }
                        vehicleService
                            .createVehicleF4(vehicleData)
                            .then((response) => {
                                if ([200, 201].includes(response.status)) {
                                    updateMembershipStatus(membership?._id)
                                } else {
                                    setIsloading(false);
                                    notify(`${response.message}` || 'error', 'error');
                                }
                            })
                            .catch((error) => {
                                setIsloading(false);
                            });
                    } else {
                        setIsloading(false);
                        notify(`${response.message}` || 'error', 'error');
                    }
                })
                .catch(() => {
                    setIsloading(false);
                });
        }
    });


    useEffect(() => {
        vehicleService
            .getSalesVehicleClasses()
            .then((response) => {
                if (response.status === 200) {
                    setVehicleClassesOptions([...response?.data?.classes || []]);
                }
            })
            .catch(() => { });
    }, []);





    const PhoneTextInput = React.forwardRef((props, ref) => (
        <input
            {...props}
            ref={ref}
            className={`f20Input f20Input--full ${errors.phone ? 'f20Input--error' : ''}`}
            placeholder="Teléfono"
            autoComplete="tel"
        />
    ));

    return (
        <>
            <LoadSpinner show={isLoading} />
            <div className="f20Landing">
                <section className="f20Hero">
                    <img className="f20Hero__image" src={DiasGratis} alt="20 días gratis" />
                </section>


                <section className="f20FormWrap">
                    {success ?
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div style={{ display: "flex", flexFlow: "column", alignItems: "center", justifyContent: "center" }}>
                                <img src={successF20} alt="Success" />
                                <button style={{ marginTop: "48px" }} type="submit" className="f20BtnPrimary" onClick={() => window.location.reload()}>Finalizar</button>
                            </div>
                        </div>
                        :
                        <>
                            <div className='f20-fill-data-container-title'>
                                <img style={{ height: "60px", marginBottom: "12px" }} src={rellenaTusDatos} alt="Rellena tus datos" className="f20TitleImage" />
                            </div>

                            <form className="f20Form" onSubmit={onSubmit} noValidate>
                                <div className="f20Group">
                                    <label className="f20Label">Nombre y apellido <span className="f20Req">*</span></label>
                                    <div className="row">
                                        <div className="f20Field col-12 col-md-6">
                                            <input
                                                className={`f20Input ${errors.firstName ? 'f20Input--error' : ''}`}
                                                placeholder="Nombre"
                                                {...register('firstName')}
                                            />
                                            {errors?.firstName?.message && (
                                                <small className="f20Error">{errors.firstName.message}</small>
                                            )}
                                        </div>
                                        <div className="f20Field col-12 col-md-6">
                                            <input
                                                className={`f20Input ${errors.lastName ? 'f20Input--error' : ''}`}
                                                placeholder="Apellido"
                                                {...register('lastName')}
                                            />
                                            {errors?.lastName?.message && (
                                                <small className="f20Error">{errors.lastName.message}</small>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="f20Group">
                                    <label className="f20Label">Cédula, Teléfono <span className="f20Req">*</span></label>
                                    <div className="row">
                                        <div className="f20Field col-4 col-md-4 col-lg-2">
                                            <select
                                                className={`f20Input ${errors.identificationType ? 'f20Input--error' : ''}`}
                                                {...register('identificationType')}
                                            >
                                                <option value=""></option>
                                                {idCodes?.map((opt) => (
                                                    <option key={opt._id} value={opt._id}>{opt.name}</option>
                                                ))}
                                            </select>
                                            {errors?.identificationType?.message && (
                                                <small className="f20Error">{errors.identificationType.message}</small>
                                            )}
                                        </div>
                                        <div className="f20Field col-8 col-md-8 col-lg-4">
                                            <input
                                                type="number"
                                                className={`f20Input ${errors.identification ? 'f20Input--error' : ''}`}
                                                placeholder="Cédula"
                                                {...register('identification')}
                                            />
                                            {errors?.identification?.message && (
                                                <small className="f20Error">{errors.identification.message}</small>
                                            )}
                                        </div>
                                        <div className="f20Field col-12 col-md-12 col-lg-6">
                                            {/* <input type="hidden" {...register('phone')} /> */}
                                            <Controller
                                                name={'phone'}
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <PhoneInput
                                                        defaultCountry="VE"
                                                        placeholder="Teléfono"
                                                        inputComponent={PhoneTextInput}
                                                        value={field.value || ''}
                                                        onChange={(val) => {
                                                            // forward value to react-hook-form
                                                            field.onChange(val);
                                                            // also try to extract and store country calling code
                                                            try {
                                                                const parsedNumber = val ? parsePhoneNumberWithError(val, 'VE') : null;
                                                                const countryCodeValue = parsedNumber ? parsedNumber.countryCallingCode : '';
                                                                setValue('countryCode', countryCodeValue, { shouldDirty: true });
                                                            } catch (error) {
                                                                setValue('countryCode', '', { shouldDirty: true });
                                                            }
                                                        }}
                                                        inputProps={{
                                                            name: 'phone',
                                                            autoComplete: 'tel',
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors?.phone?.message && (
                                                <small className="f20Error">{errors.phone.message}</small>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="f20Group">
                                    <label className="f20Label">Email <span className="f20Req">*</span></label>
                                    <div className="row">
                                        <div className="f20Field col-12">
                                            <input
                                                className={`f20Input f20Input--full ${errors.email ? 'f20Input--error' : ''}`}
                                                placeholder="Email"
                                                type="email"
                                                {...register('email')}
                                            />
                                            {errors?.email?.message && (
                                                <small className="f20Error">{errors.email.message}</small>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="f20Group">
                                    <label className="f20Label">Año,Clase,Placa <span className="f20Req">*</span></label>
                                    <div className="row">
                                        <div className="f20Field col-4 col-lg-4">
                                            <input
                                                type='number'
                                                className={`f20Input ${errors.year ? 'f20Input--error' : ''}`}
                                                placeholder="Año"
                                                {...register('year')}
                                            />
                                            {errors?.year?.message && (
                                                <small className="f20Error">{errors.year.message}</small>
                                            )}
                                        </div>
                                        <div className="f20Field col-8 col-lg-4">
                                            <select
                                                className={`f20Input ${errors.classType ? 'f20Input--error' : ''}`}
                                                {...register('classType')}
                                            >
                                                <option style={{ color: "gray" }} value="">Clase</option>
                                                {vehicleClassesOptions
                                                    ?.filter((v) => [
                                                        vehiclesEnum?.AUTOMOVIL,
                                                        vehiclesEnum?.CAMIONETA,
                                                        vehiclesEnum?.MOTO,
                                                        vehiclesEnum?.RUSTICO,
                                                    ]?.includes(v?.name))
                                                    ?.map((opt) => (

                                                        <option key={opt?._id || opt?.name} value={opt?._id}>
                                                            {capitalize(opt?.name)}
                                                        </option>
                                                    ))}
                                            </select>
                                            {errors?.classType?.message && (
                                                <small className="f20Error">{errors.classType.message}</small>
                                            )}
                                        </div>
                                        <div className="f20Field col-12 col-lg-4">
                                            <input
                                                className={`f20Input ${errors.plate ? 'f20Input--error' : ''}`}
                                                placeholder="Placa"
                                                {...register('plate')}
                                            />
                                            {errors?.plate?.message && (
                                                <small className="f20Error">{errors.plate.message}</small>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="f20Actions">
                                    <button type="submit" className="f20BtnPrimary">Enviar</button>
                                </div>
                            </form>
                        </>
                    }
                </section>
            </div>

        </>
    );
};

